import type { AsyncActionCreator } from '../types';
import { createAsyncAction } from '../utils';
import type { GetDispatchPage, GetLocationSearch } from './dispatchTypes';
import { ActionType } from './dispatchTypes';

export const getLocationSearch = createAsyncAction<GetLocationSearch>({
  request: ActionType.GET_LOCATION_SEARCH_REQUEST,
})((payload: GetLocationSearch['request']['payload']) => ({ payload }));

export const getDispatchPage: AsyncActionCreator<
  GetDispatchPage,
  (payload: GetDispatchPage['request']['payload']) => {
    payload: GetDispatchPage['request']['payload'];
  }
> = createAsyncAction<GetDispatchPage>({
  request: ActionType.GET_DISPATCH_PAGE_REQUEST,
  success: ActionType.GET_DISPATCH_PAGE_SUCCESS,
  failure: ActionType.GET_DISPATCH_PAGE_FAILURE,
})((payload: GetDispatchPage['request']['payload']) => ({ payload }));
